import React from 'react';
import { Button } from 'antd';
import parse from '../../internals/link-parser';

const LinkButton = props => {
    let { href } = props;
    href = parse(href);
    return (
        <Button {...props} href={href}>
            {props.children}
        </Button>
    );
};

export default LinkButton;
